<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1>Paramètres</h1>
    </div>

  <b-col><!-- General settings -->
    <b-row><h2>Paramètres généraux</h2></b-row>

    <b-row>

      <!-- Titre -->
      <b-col md="12">
        <h3 class="my-3">Meta</h3>
      </b-col>
      <b-col md="2">
        <label for="setting_title_name">Titre du site</label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.home_title | translategrader(lang)"
          placeholder="Okédito Grader <sup>®</sup>"
          id="setting_title_name"
          @input="updateSettingsCopy($event, 'home_title')">
        </b-form-input>
        <p class="text-info small mt-1">Titre du site : apparait sur la landing page de home, sur le mini-header des pages "Question" ainsi que sur la page de résultat. HTML possible</p>
      </b-col>
    </b-row>

      <!-- Sous titre -->
    <b-row>
      <b-col md="2">
        <label for="setting_subtitle_name">Sous-titre du site</label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.home_subtitle | translategrader(lang)"
          placeholder="Évaluez la performance de votre inbound marketing"
          id="setting_subtitle_name"
          @input="updateSettingsCopy($event, 'home_subtitle')">
        </b-form-input>
        <p class="text-info small mt-1">Sous-titre du site : apparait sur la landing page de home. HTML possible</p>
      </b-col>

      <!-- Meta Descr. -->
      <b-col md="2">
        <label>Meta description</label>
      </b-col>
      <b-col md="10">
        <b-form-textarea
          :value="settings.copy.meta_description | translategrader(lang)"
          placeholder="Évaluez la performance de votre inbound marketing"
          @input="updateSettingsCopy($event, 'meta_description')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-danger small">Not implemented yet</p>
        <p class="text-info small mt-1">Meta description du site : apparait sur la landing page de home.</p>
      </b-col>
    </b-row>

     <!-- Brand settings -->
    <b-row>
      <b-col md="12">
        <h2>Branding</h2>
      </b-col>
    </b-row>


    <b-row>
      <b-col md="12">
        <h4>Branding - Couleurs</h4>
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Couleur principale</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <span class="colorDemo" :style="bgc_primary" @click="showColorPicker('primary')">&nbsp;</span></p>
        <div class="colorPicker">
          <photoshop-picker :value="tempColor" @input="updateTempColor" @ok="updateColor('primary')" @cancel="closeColorPicker" v-if="showingColorPicker['primary']"></photoshop-picker>
        </div>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <b-form-input v-model="settings.colors.primary" placeholder="Couleur de la section" @click="showColorPicker('primary')"></b-form-input>
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Couleur secondaire</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <span class="colorDemo" :style="bgc_secondary" @click="showColorPicker('secondary')">&nbsp;</span></p>
        <div class="colorPicker">
          <photoshop-picker :value="tempColor" @input="updateTempColor" @ok="updateColor('secondary')" @cancel="closeColorPicker" v-if="showingColorPicker['secondary']"></photoshop-picker>
        </div>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <b-form-input v-model="settings.colors.secondary" placeholder="Couleur de la section" @click="showColorPicker('secondary')"></b-form-input>
      </b-col>
    </b-row>

     <!-- Logo -->
    <b-row>
      <b-col md="12">
        <h4>Logos du site</h4>
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Logo principal (landing + report page)</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <b-button @click="open_uploadcare('main')"  class="pull-left">Sélectionner une image</b-button>
        <p class="text-info pt-2 small pull-right">Taille suggérée : 350 x 200px</p>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <img :src="settings.logos.main" class="img-fluid demo-img" />
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Logo "Section Header" - Dark Logo</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <b-button @click="open_uploadcare('header_overlay')"  class="pull-left">Sélectionner une image</b-button>
        <p class="text-info pt-2 small pull-right">L'image sera en général sombre car elle apparait sur fond clair. <br/>Taille suggérée : 250 x 90px</p>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <img :src="settings.logos.header_overlay" class="img-fluid demo-img" />
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Logo "Section Title Bar" - Light Logo</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <b-button @click="open_uploadcare('header_title')"  class="pull-left">Sélectionner une image</b-button>
        <p class="text-info pt-2 small pull-right">L'image sera en général claire car elle apparait sur fond sombre. <br/>Taille suggérée : 250 x 90px</p>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <img :src="settings.logos.header_title" class="img-fluid demo-img" />
      </b-col>

    </b-row>

    <!-- Landing -->
    <b-row>
      <b-col md="12">
        <h4>Landing Page</h4>
      </b-col>

      <b-col md="2">
        <label for="setting_main_logo">Image de landing page</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <b-button @click="open_uploadcare('landing_image')"  class="pull-left">Sélectionner une image</b-button>
        <p class="text-info pt-2 small pull-right">Taille suggérée : 700 x 400px</p>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <img :src="settings.logos.landing_image" class="img-fluid demo-img" />
      </b-col>
    </b-row>

    <b-row class="mt-3 pt-3">
        <!-- Titre -->
        <b-col md="12" class="px-0">
          <h3 class="my-3">Text on Home</h3>
        </b-col>
        <b-col md="2">
          <label>Titre section #1</label>
        </b-col>
        <b-col md="10">
          <b-form-input
            :value="settings.copy.home_section_1_title | translategrader(lang)"
            placeholder="Pour quoi faire ?"
            @input="updateSettingsCopy($event, 'home_section_1_title')">
          </b-form-input>
          <p class="text-info small mt-1">Titre de la première section</p>
        </b-col>

        <b-col md="2">
          <label>Texte section #1</label>
        </b-col>
        <b-col md="10">
          <b-form-textarea
            :value="settings.copy.home_section_1_text | translategrader(lang)"
            placeholder="Évaluez la performance de votre inbound marketing"
            @input="updateSettingsCopy($event, 'home_section_1_text')"
            rows="3"
            max-rows="6">
          </b-form-textarea>
          <p class="text-info small mt-1">Paragraphe de la première section. HTML possible</p>
        </b-col>

        <b-col md="2">
          <label>Titre section #2</label>
        </b-col>
        <b-col md="10">
          <b-form-input
            :value="settings.copy.home_section_2_title | translategrader(lang)"
            placeholder="Pour quoi faire ?"
            @input="updateSettingsCopy($event, 'home_section_2_title')">
          </b-form-input>
          <p class="text-info small mt-1">Titre de la seconde section</p>
        </b-col>

        <b-col md="2">
          <label>Texte section #2</label>
        </b-col>
        <b-col md="10">
          <b-form-textarea
            :value="settings.copy.home_section_2_text | translategrader(lang)"
            placeholder="Évaluez la performance de votre inbound marketing"
            @input="updateSettingsCopy($event, 'home_section_2_text')"
            rows="3"
            max-rows="6">
          </b-form-textarea>
          <p class="text-info small mt-1">Paragraphe de la seconde section. HTML possible</p>
        </b-col>

        <b-col md="2">
          <label>Titre section #3</label>
        </b-col>
        <b-col md="10">
          <b-form-input
            :value="settings.copy.home_section_3_title | translategrader(lang)"
            placeholder="On y va ?"
            @input="updateSettingsCopy($event, 'home_section_3_title')">
          </b-form-input>
          <p class="text-info small mt-1">Titre de la troisième section</p>
        </b-col>
    </b-row>
  </b-col>

  <b-col><!-- Result settings -->

    <b-row class="border-top mt-3 pt-3">
      <b-col md="12">
        <h2>Page de résultats</h2>
      </b-col>

      <!-- Texte de teasing pour obtenir tous les résultats (page info additionnelles) quand bons résultats -->
      <b-col md="2">
        <label>Texte "Bravo, obtenez vos résultats"</label>
      </b-col>
      <b-col md="10" class="mb-4">
        <b-form-textarea
          :value="settings.copy.additionnal_info_get_results_good | translategrader(lang)"
          placeholder="<p>Vous êtes très bon. Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.</p>"
          @input="updateSettingsCopy($event, 'additionnal_info_get_results_good')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe apparaissant sur la page de gating avant les résultats complets (score global >= 50). HTML possible</p>
      </b-col>

      <!-- Texte de teasing pour obtenir tous les résultats (page info additionnelles) quand mauvais résultats -->
      <b-col md="2">
        <label>Texte "C'est bof, obtenez vos résultats"</label>
      </b-col>
      <b-col md="10" class="mb-4">
        <b-form-textarea
          :value="settings.copy.additionnal_info_get_results_bad | translategrader(lang)"
          placeholder="<p>Vous pouvez vous améliorez. Pour accéder à vos résultats détaillés, découvrir les bonnes pratiques associées et bénéficier de nos conseils, merci de bien vouloir remplir ce formulaire.</p>"
          @input="updateSettingsCopy($event, 'additionnal_info_get_results_bad')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe apparaissant sur la page de gating avant les résultats complets (score global < 50). HTML possible</p>
      </b-col>


      <!-- Bouton call page (stiky footer) -->
      <b-col md="2">
        <label for="call_back_text" >Texte bouton Call back<i class="fa fa-question-circle text-info" v-b-tooltip.hover title="Texte du bouton de callback en fin de diagnostic"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.expert_callback_text | translategrader(lang)"
          placeholder="Etre contacté par un expert"
          id="call_back_text"
          @input="updateSettingsCopy($event, 'expert_callback_text')">
        </b-form-input>
        <p class="text-info small mt-1">
        ex: https://www.okedito.com/expert_callback/?utm_source=autodiag&utm_medium=cta&utm_campaign=footer_resultat
        </p>
      </b-col>

      <!-- Bouton call page (stiky footer) -->
      <b-col md="2">
        <label for="setting_social_icons_share_linkedin" >Lien bouton Call back<i class="fa fa-question-circle text-info" v-b-tooltip.hover title="Lien vers la page de callback en fin de diagnostic"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.expert_callback_link | translategrader(lang)"
          placeholder="https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=linkedin&utm_medium=social_share&utm_campaign=header_campaign_1"
          id="setting_social_icons_share_linkedin"
          @input="updateSettingsCopy($event, 'expert_callback_link')">
        </b-form-input>
        <p class="text-info small mt-1">
        ex: https://www.okedito.com/expert_callback/?utm_source=autodiag&utm_medium=cta&utm_campaign=footer_resultat
        </p>
      </b-col>

    </b-row>

  </b-col>






  <b-col><!-- Forms settings -->

    <b-row class="border-top mt-3 pt-3">
      <b-col md="12">
        <h2>Paramètre de captation de lead</h2>
      </b-col>

      <!-- Form on Landing page -->
      <b-col md="12" class="my-3">
        <h3 class="my-3">Show form on landing page?</h3>
        <p>
          <b-form-checkbox v-model="settings.forms.showing_form_landing" name="check-button" switch class="mt-2 pull-left" @change="switchFormLandingOrderState">
            &nbsp;
          </b-form-checkbox>
          <span v-if="settings.forms.showing_form_landing">Form visible landing</span></p>
          <span v-if="!settings.forms.showing_form_landing">Form is hidden on landing</span>
        </p>
      </b-col>

      <b-collapse id="collapse-integration-ga" v-model="settings.forms.showing_form_landing" class="col-md-12 mt-2">
        <b-row>

          <b-col md="2">
            <label for="setting_title_name">Landing page Form ID in CRM</label>
          </b-col>

          <b-col md="10">
            <b-form-input
              :value="settings.forms.hubspot_form_landing_id | translategrader(lang)"
              placeholder="36645"
              @input="updateSettingsForms($event, 'hubspot_form_landing_id')">
            </b-form-input>
            <p class="text-info small mt-1">L'id du formulaire à utiliser sur la landing page. Contient d'habitude uniquement 'email'.</p>
          </b-col>

        </b-row>
      </b-collapse>

      <!-- Form on Result page -->
      <b-col md="12" class="my-3">
        <h3 class="my-3">Show form on result page?</h3>
        <p>
          <b-form-checkbox v-model="settings.forms.showing_form_result" name="check-button" switch class="mt-2 pull-left" @change="switchFormResultOrderState">
            &nbsp;
          </b-form-checkbox>
          <span v-if="settings.forms.showing_form_result">Form visible result</span></p>
          <span v-if="!settings.forms.showing_form_result">Form is hidden on result</span>
        </p>
      </b-col>

      <b-collapse id="collapse-integration-ga" v-model="settings.forms.showing_form_result" class="col-md-12 mt-2">
        <b-row>

          <b-col md="2">
            <label for="setting_title_name">Result page Form ID in CRM</label>
          </b-col>

          <b-col md="10">
            <b-form-input
              :value="settings.forms.hubspot_form_result_id | translategrader(lang)"
              placeholder="36645"
              @input="updateSettingsForms($event, 'hubspot_form_result_id')">
            </b-form-input>
            <p class="text-info small mt-1">L'id du formulaire à utiliser sur la result page. Contient d'habitude  la plupart des champs.</p>
          </b-col>

        </b-row>
      </b-collapse>

    </b-row>

  </b-col>

  <b-col><!-- Social Settings -->
    <b-row  class="border-top mt-3 pt-3">
      <b-col md="12">
        <h2>Social Settings</h2>
      </b-col>
      <!-- Facebook Share -->
      <b-col md="2">
        <label for="setting_social_icons_share_facebook">URL du partage Facebook <i class="fa fa-question-circle text-info" v-b-tooltip.hover title="URL à partager sur Facebook : dans le Header, des icones réseaux sociaux apparaissent et lorsque l'on clique dessus, l'url ci-contre sera partagée. (Texte vide = L'icone n'apparaitra pas)"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.social_icons_share_facebook | translategrader(lang)"
          placeholder="https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=facebook&utm_medium=social_share&utm_campaign=header_campaign_1"
          id="setting_social_icons_share_facebook"
          @input="updateSettingsCopy($event, 'social_icons_share_facebook')">
        </b-form-input>
        <p class="text-info small mt-1">ex: https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=facebook&utm_medium=social_share&utm_campaign=header_campaign_1</p>
      </b-col>

      <!-- Linkedin Share -->
      <b-col md="2">
        <label for="setting_social_icons_share_linkedin" >URL du partage Linkedin <i class="fa fa-question-circle text-info" v-b-tooltip.hover title="URL à partager sur Linkedin : dans le Header, des icones réseaux sociaux apparaissent et lorsque l'on clique dessus, l'url ci-contre sera partagée. (Texte vide = L'icone n'apparaitra pas)"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.social_icons_share_linkedin | translategrader(lang)"
          placeholder="https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=linkedin&utm_medium=social_share&utm_campaign=header_campaign_1"
          id="setting_social_icons_share_linkedin"
          @input="updateSettingsCopy($event, 'social_icons_share_linkedin')">
        </b-form-input>
        <p class="text-info small mt-1">
        ex: https://www.okedito.com/diagnostic-inbound-marketing/?utm_source=linkedin&utm_medium=social_share&utm_campaign=header_campaign_1
        </p>
      </b-col>

      <!-- Twitter Share -->
      <b-col md="2">
        <label for="setting_social_icons_share_twitter">Texte du partage Twitter <i class="fa fa-question-circle text-info" v-b-tooltip.hover title="Texte du partage Twitter : dans le Header, des icones réseaux sociaux apparaissent et lorsque l'on clique dessus, le message ci-contre sera partagé. N'oubliez pas d'insérer l'url du greader. (Texte vide = L'icone n'apparaitra pas)"></i></label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.social_icons_share_twitter | translategrader(lang)"
          placeholder="Je suis en train d’évaluer gratuitement la maturité #inboundmarketing de mon entreprise sur http://bit.ly/score_inbound_marketing  6 thématiques, 45 questions pour faire le point ! Via @OkeditoAgency"
          id="setting_social_icons_share_twitter"
          @input="updateSettingsCopy($event, 'social_icons_share_twitter')">
        </b-form-input>
        <p class="text-info small mt-1"> ex: Je suis en train d’évaluer gratuitement la maturité #inboundmarketing de mon entreprise sur http://bit.ly/score_inbound_marketing  6 thématiques, 45 questions pour faire le point ! Via @OkeditoAgency</p>
      </b-col>
    </b-row>
  </b-col>

  <b-col><!-- Misc settings -->
    <b-row  class="border-top mt-3 pt-3">
      <b-col md="12">
        <h2>Misc Settings</h2>
      </b-col>

      <!-- <b-col md="12" class="border-top">
        <h3 class="my-3">Langues</h3>
        <p class="text-danger">Not implemented yet</p>
      </b-col>

      <b-form-group label="Choisir les langues du grader :">
        <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="selectedLang"
          :options="optionsLang"
          name="lang-1"
          @change="updateLanguages($event)"

        ></b-form-checkbox-group>
      </b-form-group>

      <b-col>
        Langue par défaut :
      </b-col> -->
    </b-row>

    <b-row>
      <b-col md="12" class="my-3">
        <h3 class="my-3">Show question in order</h3>
        <p>
          <b-form-checkbox v-model="settings.show_question_ordered" name="check-button" switch class="mt-2 pull-left" @change="switchQuestionOrderState">
          &nbsp;
          </b-form-checkbox>
          <span v-if="settings.show_question_ordered">Show in order</span></p>
          <span v-if="!settings.show_question_ordered">Show in random order</span></p>
      </b-col>
    </b-row>

    <b-row class="border-top mt-3 pt-3">
      <b-col md="12">
        <h2>Intégrations</h2>
      </b-col>
    </b-row>

    <b-row><p class="text-danger">Not implemented yet</p></b-row>

    <b-row>
      <b-form-checkbox v-model="settings.integrations.google_analytics.enabled" name="check-button" switch class="mt-2" @change="switchGAState">
        &nbsp;
      </b-form-checkbox>
      <h3>Google Analytics</h3>
    </b-row>

    <b-row>
      <b-collapse id="collapse-integration-ga" v-model="settings.integrations.google_analytics.enabled" class="col-md-12 px-0 mt-2">
        <!-- <b-row> -->
          <!-- <b-col md="12"> -->
            <b-card title="Google analytics settings" tag="col">
              <b-form-input v-model="settings.integrations.google_analytics.tracking_id" placeholder="UA-52137172-1" @input="updateGATrackingID"></b-form-input>
              <p class="text-info small">Accessible sur Google Analytics, dans la zone d'admin, au niveau des "paramètres de la propriété"</p>
            </b-card>
          <!-- </b-col> -->
        <!-- </b-row> -->
      </b-collapse>
    </b-row>

    <b-row class="mt-4">
      <b-form-checkbox v-model="settings.integrations.gtm.enabled" name="check-button" switch class="mt-2" @change="switchGAState">
        &nbsp;
      </b-form-checkbox>
      <h3>Google Tag Manager</h3>
    </b-row>
    <b-row>
      <b-collapse id="collapse-integration-ga" v-model="settings.integrations.gtm.enabled" class="col-md-12 px-0 mt-2">
        <!-- <b-row> -->
          <!-- <b-col md="12"> -->
            <b-card title="Google analytics settings" tag="col">
              <b-form-input v-model="settings.integrations.google_analytics.tracking_id" placeholder="UA-52137172-1" @input="updateGATrackingID"></b-form-input>
              <p class="text-info small">Accessible sur Google Analytics, dans la zone d'admin, au niveau des "paramètres de la propriété"</p>
            </b-card>
          <!-- </b-col> -->
        <!-- </b-row> -->
      </b-collapse>
    </b-row>

    <b-row class="mt-4">
      <b-form-checkbox v-model="settings.integrations.zapier.enabled" name="check-button" switch class="mt-2" @change="switchGAState">
        &nbsp;
      </b-form-checkbox>
      <h3>Zapier</h3>
    </b-row>
    <b-row>
      <b-collapse id="collapse-integration-ga" v-model="settings.integrations.zapier.enabled" class="col-md-12 px-0 mt-2">
        <!-- <b-row> -->
          <!-- <b-col md="12"> -->
            <b-card title="Google analytics settings" tag="col">
              <b-form-input v-model="settings.integrations.google_analytics.tracking_id" placeholder="UA-52137172-1" @input="updateGATrackingID"></b-form-input>
              <p class="text-info small">Accessible sur Google Analytics, dans la zone d'admin, au niveau des "paramètres de la propriété"</p>
            </b-card>
          <!-- </b-col> -->
        <!-- </b-row> -->
      </b-collapse>
    </b-row>

    <b-row class="mt-4">
      <b-form-checkbox v-model="settings.integrations.hubspot.enabled" name="check-button" switch class="mt-2" @change="switchGAState">
        &nbsp;
      </b-form-checkbox>
      <h3>HubSpot</h3>
    </b-row>
    <b-row>
      <b-collapse id="collapse-integration-ga" v-model="settings.integrations.hubspot.enabled" class="col-md-12 px-0 mt-2">
        <!-- <b-row> -->
          <!-- <b-col md="12"> -->
            <b-card title="Hubspot" tag="col">
              <b-form-input v-model="settings.integrations.hubspot.portalID" placeholder="52137172" @input="updateGATrackingID"></b-form-input>
              <p class="text-info small">Votre portalID, accessible dans l'URL de votre compte HubSpot. Ex: pour https://app.hubspot.com/settings/<b>5878745</b>/ le portalID serait <b>5878745</b></p>
            </b-card>
          <!-- </b-col> -->
        <!-- </b-row> -->
      </b-collapse>
    </b-row>

    <b-row>
      <p>&nbsp;
        <b-button variant="primary" disabled class="spinnerSave" v-if="isSaving">
          <b-spinner small type="grow"></b-spinner>
          Saving...
        </b-button>
      </p>
    </b-row>

  </b-col>

  </div>

</template>

<script>

  import { mapGetters, mapActions } from 'vuex';
  import { Photoshop } from 'vue-color'

  export default {

    name: 'admin_settings',

    data() {
      return {
        selectedLang: [], // Must be an array reference!
        optionsLang: [
          { text: 'Français', value: 'fr' },
          { text: 'English', value: 'en' },
          { text: 'Italiano', value: 'it' },
          { text: 'Deutsch', value: 'de' }
        ],
        checked: false,
        showingColorPicker: {'primary': false, 'secondary': false},
        tempColor: "#fff",
      }
    },

    components: {
      'photoshop-picker': Photoshop,
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings',
        isSaving: 'isSaving'
      }),

      bgc_primary : function() {
        return {backgroundColor: this.settings.colors.primary};
      },

      bgc_secondary : function() {
        return {backgroundColor: this.settings.colors.secondary};
      },

      lang : function() {
        return this.$i18n.locale;
      },
    },

    async created() {
      await this.getOrCreateSetting();
      if (Array.isArray(this.settings.available_lang)) {
        this.selectedLang = this.settings.available_lang;
      }
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
        saveSettings: 'settings/saveSettings'
      }),

      open_uploadcare (image_name) {
        // var dialog = uploadcare.openDialog(this.quiz.background_image);
        var currentComponent = this;
        var fileInput = document.createElement('input');
        var widget = uploadcare.Widget(fileInput);
        widget.onUploadComplete(function(info) {
          console.log("File info!", info.cdnUrl);
          currentComponent.updateLogo(image_name, info.cdnUrl)
        });
        widget.openDialog();
      },

      updateLogo(image_name, url) {
        var tmpSettings = this.settings;
        tmpSettings["logos"][image_name] = url;
        this.saveSettings(tmpSettings);
      },

      updateLanguages(event) {
        var tmpSettings = this.settings;
        tmpSettings.available_lang = event;
        this.saveSettings(tmpSettings);
      },

      updateSettingsCopy(value, targetKey) {
        // Saving title in current language
        var tmpSettings = this.settings;
        if (typeof this.$i18n.locale === "undefined") {
          tmpSettings.copy[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        }
        else {
          if (typeof tmpSettings.copy[targetKey] !== 'undefined' && tmpSettings.copy[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSettings.copy[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            var newSettings = tmpSettings.copy;
            delete newSettings[targetKey];
            newSettings[targetKey] = {};
            newSettings[targetKey][this.$i18n.locale] = value;
          }
        }
        this.saveSettings(tmpSettings);
      },

      updateSettingsForms(value, targetKey) {
        // Saving title in current language
        var tmpSettings = this.settings;
        if (typeof this.$i18n.locale === "undefined") {
          tmpSettings.forms[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        }
        else {
          if (typeof tmpSettings.forms[targetKey] !== 'undefined' && tmpSettings.forms[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSettings.forms[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            var newSettings = tmpSettings.forms;
            delete newSettings[targetKey];
            newSettings[targetKey] = {};
            newSettings[targetKey][this.$i18n.locale] = value;
          }
        }
        this.saveSettings(tmpSettings);
      },

      closeColorPicker () {
        this.showingColorPicker["primary"] = false;
        this.showingColorPicker["secondary"] = false;
        console.log(this.showingColorPicker);
      },

      updateColor(color_choice) {
        var tmpSettings = this.settings;
        tmpSettings.colors[color_choice] = this.tempColor;
        this.saveSettings(tmpSettings);
        this.closeColorPicker();
      },

      showColorPicker (color_choice) {
        this.tempColor = this.settings.colors[color_choice];
        this.showingColorPicker[color_choice] = true;
      },

      // Integration switches
      switchZapierState() {
        var tmpSettings = this.settings;
        tmpSettings.integrations.zapier.enabled = !this.settings.integrations.zapier.enabled;
        this.saveSettings(tmpSettings);
      },

      switchFormLandingOrderState() {
        var tmpSettings = this.settings;
        tmpSettings.forms.showing_form_landing = !this.settings.forms.showing_form_landing;
        this.saveSettings(tmpSettings);
      },

      switchFormResultOrderState() {
        var tmpSettings = this.settings;
        tmpSettings.forms.showing_form_result = !this.settings.forms.showing_form_result;
        this.saveSettings(tmpSettings);
      },

      switchGAState() {
        var tmpSettings = this.settings;
        tmpSettings.integrations.google_analytics.enabled = !this.settings.integrations.google_analytics.enabled;
        this.saveSettings(tmpSettings);
      },

      switchQuestionOrderState() {
        var tmpSettings = this.settings;
        tmpSettings.show_question_ordered = !this.settings.show_question_ordered;
        this.saveSettings(tmpSettings);
      },

      // Integrations settings
      updateGATrackingID(value) {
        var tmpSettings = this.settings;
        tmpSettings.integrations.google_analytics.tracking_id = value;
        this.saveSettings(tmpSettings);
      },

      // Hubspot portalID
      updateHSPortalID(value) {
        var tmpSettings = this.settings;
        tmpSettings.integrations.hubspot.portalID = value;
        this.saveSettings(tmpSettings);
      },

      // Setting for color picker
      updateTempColor(value) {
        this.tempColor = value.hex;
      },
    },

  }
</script>



<style scoped>
h2 {
  color: #005E88;
}

.colorDemo {
  float: right;
  width: 15px;
  height: 15px;
  border: 1px solid #DDD;
  background-color: #0000F2;
}

.demo-img {
  background: #eee;
  padding: 20px;
}

.spinnerSave {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.vc-photoshop {
  position: absolute;
  right: 0px;
  top: 50px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminSettings.vue